import axios from 'axios';

const api = axios.create({
  baseURL: process.env.API_ROOT,
});

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js